/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react'

export type Props = {
  injuries?: any[]
  handleChangeInjury?: (name: string, value: string) => void
  handleChangeInjurySimulation?: (e: React.FormEvent<HTMLInputElement>) => void
  forceUpdate?: () => void
}

export type Injury = {
  name: string
  active: boolean
  lesion: React.CSSProperties
  simulation: React.CSSProperties
  movable: boolean
  controlledPosition: {
    x: number
    y: number
  }
  onInjuryDrag?: (
    e: {
      preventDefault: () => void
      stopPropagation: () => void
    },
    position: {
      x: any
      y: any
    }
  ) => void
  onSimulationDrag?: (
    e: {
      preventDefault: () => void
      stopPropagation: () => void
    },
    position: {
      x: any
      y: any
    }
  ) => void
}

export type InjuryProps = {
  other?: string
} & Props
export const InjuryContext = React.createContext<InjuryProps>({})

export const InjuryProvider: React.FC = ({ children }) => {
  const initialPosition = {
    x: 678,
    y: 404
  }
  const glaucomaInitialPosition = {
    x: 0,
    y: 0
  }
  const dmriInjury: React.CSSProperties = {
    background: '#000',
    borderRadius: '50%',
    width: '30px',
    height: '30px',
    margin: '10px',
    padding: '10px',
    filter: 'blur(8px)',
    position: 'absolute'
  }

  const dmriScaled: React.CSSProperties = {
    background: '#000',
    width: '120px',
    height: '120px',
    borderRadius: '50%',
    margin: '10px',
    padding: '10px',
    filter: 'blur(20px)',
    position: 'absolute'
  }

  const glaucomaInjury: React.CSSProperties = {
    background:
      'radial-gradient(circle, rgba(0,0,0,1) 0%, rgba(255,255,255,0) 0%, rgba(0,0,0,1) 45%)',
    width: '100%',
    height: '100%',
    position: 'absolute'
  }
  const dmriInitial = {
    name: 'dmri',
    active: false,
    lesion: dmriInjury,
    simulation: dmriScaled,
    movable: true,
    controlledPosition: initialPosition,
    onInjuryDrag: undefined,
    onSimulationDrag: undefined
  }
  const buracoInitial = {
    name: 'buraco macular',
    active: false,
    lesion: dmriInjury,
    simulation: dmriScaled,
    movable: true,
    controlledPosition: initialPosition,
    onInjuryDrag: undefined,
    onSimulationDrag: undefined
  }
  const toxoplasmoseInitial = {
    name: 'toxoplasmose',
    active: false,
    lesion: dmriInjury,
    simulation: dmriScaled,
    movable: true,
    controlledPosition: initialPosition,
    onInjuryDrag: undefined,
    onSimulationDrag: undefined
  }
  const glaucomaInitial = {
    name: 'glaucoma',
    active: false,
    lesion: {},
    simulation: glaucomaInjury,
    movable: true,
    controlledPosition: glaucomaInitialPosition,
    onInjuryDrag: undefined,
    onSimulationDrag: undefined
  }

  const [dmri, setDmri] = React.useState<Injury>(dmriInitial)
  const [buraco, setBuraco] = React.useState<Injury>(buracoInitial)
  const [toxoplasmose, setToxoplasmose] = React.useState<Injury>(
    toxoplasmoseInitial
  )
  const [glaucoma, setGlaucoma] = React.useState<Injury>(glaucomaInitial)

  const forceUpdate = () => {
    setDmri(dmriInitial)
    setBuraco(buracoInitial)
    setToxoplasmose(toxoplasmoseInitial)
    setGlaucoma(glaucomaInitial)
    setTimeout(() => {
      setChangers()
    }, 1000)
  }

  const setChangers = () => {
    setDmri(dmri => ({
      ...dmri,
      onInjuryDrag: onInjuryDragDmri,
      onSimulationDrag: onSimulationDragDmri
    }))
    setBuraco(buraco => ({
      ...buraco,
      onInjuryDrag: onInjuryDragBuraco,
      onSimulationDrag: onSimulationDragBuraco
    }))
    setGlaucoma(glaucoma => ({
      ...glaucoma,
      onInjuryDrag: onInjuryDragBuraco,
      onSimulationDrag: onSimulationDragBuraco
    }))
    setToxoplasmose(toxoplasmose => ({
      ...toxoplasmose,
      onInjuryDrag: onInjuryDragToxoplasmose,
      onSimulationDrag: onSimulationDragToxoplasmose
    }))
  }

  const injuries = [dmri, buraco, glaucoma, toxoplasmose]
  const diference = (screen.width - 260) / 252

  const onInjuryDragDmri = (
    e: { preventDefault: () => void; stopPropagation: () => void },
    position: { x: any; y: any }
  ) => {
    const { x, y } = position

    setDmri(injury => ({
      ...injury,
      controlledPosition: { x: x * diference, y: y * 4 }
    }))
  }

  const onSimulationDragDmri = (
    e: { preventDefault: () => void; stopPropagation: () => void },
    position: { x: any; y: any }
  ) => {
    const { x, y } = position

    setDmri(injury => ({ ...injury, controlledPosition: { x, y } }))
  }

  const onInjuryDragBuraco = (
    e: { preventDefault: () => void; stopPropagation: () => void },
    position: { x: any; y: any }
  ) => {
    const { x, y } = position

    setBuraco(injury => ({
      ...injury,
      controlledPosition: { x: x * diference, y: y * 4 }
    }))
  }

  const onSimulationDragBuraco = (
    e: { preventDefault: () => void; stopPropagation: () => void },
    position: { x: any; y: any }
  ) => {
    const { x, y } = position

    setBuraco(injury => ({ ...injury, controlledPosition: { x, y } }))
  }

  const onInjuryDragToxoplasmose = (
    e: { preventDefault: () => void; stopPropagation: () => void },
    position: { x: any; y: any }
  ) => {
    const { x, y } = position

    setToxoplasmose(injury => ({
      ...injury,
      controlledPosition: { x: x * diference, y: y * 4 }
    }))
  }

  const onSimulationDragToxoplasmose = (
    e: { preventDefault: () => void; stopPropagation: () => void },
    position: { x: any; y: any }
  ) => {
    const { x, y } = position

    setToxoplasmose(injury => ({ ...injury, controlledPosition: { x, y } }))
  }

  const handleChangeInjury = (name: string, value: string) => {
    if (Number(value) > 0) {
      switch (name) {
        case 'dmri':
          setDmri(injury => ({
            ...injury,
            active: true,
            lesion: {
              ...injury.lesion,
              width: Number(value),
              height: Number(value)
            },
            simulation: {
              ...injury.simulation,
              width: Number(value) * diference,
              height: Number(value) * diference
            }
          }))
          break
        case 'buraco macular':
          setBuraco(injury => ({
            ...injury,
            active: true,
            lesion: {
              ...injury.lesion,
              width: Number(value),
              height: Number(value)
            },
            simulation: {
              ...injury.simulation,
              width: Number(value) * diference,
              height: Number(value) * diference
            }
          }))
          break
        case 'toxoplasmose':
          setToxoplasmose(injury => ({
            ...injury,
            active: true,
            lesion: {
              ...injury.lesion,
              width: Number(value),
              height: Number(value)
            },
            simulation: {
              ...injury.simulation,
              width: Number(value) * diference,
              height: Number(value) * diference
            }
          }))
          break
        case 'glaucoma':
          setGlaucoma(injury => ({
            ...injury,
            active: true,
            simulation: {
              ...injury.simulation,
              background: `radial-gradient(circle, rgba(255,255,255,0) 0%, rgba(0,0,0,0.98) ${
                110 - Number(value)
              }%)`
            }
          }))
          break
      }
    } else {
      switch (name) {
        case 'dmri':
          setDmri(injury => ({
            ...injury,
            active: false,
            controlledPosition: initialPosition
          }))
          break
        case 'buraco':
          setBuraco(injury => ({
            ...injury,
            active: false,
            controlledPosition: initialPosition
          }))
          break
        case 'glaucoma':
          setGlaucoma(injury => ({
            ...injury,
            active: false,
            controlledPosition: glaucomaInitialPosition
          }))
          break
      }
    }
  }

  const handleChangeInjurySimulation = (
    e: React.FormEvent<HTMLInputElement>
  ) => {
    const { name, value } = e.currentTarget
    if (value !== '') {
      switch (name) {
        case 'dmri':
          setDmri(injury => ({
            ...injury,
            active: true,
            movable: false,
            controlledPosition: initialPosition,
            simulation: {
              width: '100%',
              height: '100%',
              background: `url(${value})`,
              position: 'absolute'
            }
          }))
          break
        case 'buraco macular':
          setBuraco(injury => ({
            ...injury,
            active: true,
            movable: false,
            controlledPosition: initialPosition,
            simulation: {
              width: '100%',
              height: '100%',
              background: `url(${value})`,
              position: 'absolute'
            }
          }))
          break
        case 'toxoplasmose':
          setToxoplasmose(injury => ({
            ...injury,
            active: true,
            movable: false,
            controlledPosition: initialPosition,
            simulation: {
              width: '100%',
              height: '100%',
              background: `url(${value})`,
              position: 'absolute'
            }
          }))
          break
        case 'glaucoma':
          setGlaucoma(injury => ({
            ...injury,
            active: true,
            movable: false,
            controlledPosition: glaucomaInitialPosition,
            simulation: {
              width: '100%',
              height: '100%',
              background: `url(${value})`,
              position: 'absolute'
            }
          }))
          break
      }
    } else {
      switch (name) {
        case 'dmri':
          setDmri(injury => ({
            ...injury,
            active: false,
            movable: true,
            controlledPosition: initialPosition,
            simulation: dmriScaled
          }))
          break
        case 'buraco':
          setBuraco(injury => ({
            ...injury,
            active: false,
            movable: true,
            controlledPosition: initialPosition,
            simulation: dmriScaled
          }))
          break
        case 'toxoplasmose':
          setToxoplasmose(injury => ({
            ...injury,
            active: false,
            movable: true,
            controlledPosition: initialPosition,
            simulation: dmriScaled
          }))
          break
        case 'glaucoma':
          setGlaucoma(injury => ({
            ...injury,
            active: false,
            movable: false,
            controlledPosition: glaucomaInitialPosition,
            simulation: glaucomaInjury
          }))
          break
      }
    }
  }

  React.useEffect(() => {
    setChangers()
    return () => {
      setChangers()
    }
  }, [])

  return (
    <InjuryContext.Provider
      value={{
        injuries,
        handleChangeInjury,
        handleChangeInjurySimulation,
        forceUpdate
      }}
    >
      {children}
    </InjuryContext.Provider>
  )
}

export const useInjuries = (): InjuryProps => React.useContext(InjuryContext)
